import { render, staticRenderFns } from "./accountSettingsixth.vue?vue&type=template&id=4f6560af&scoped=true"
import script from "./accountSettingsixth.vue?vue&type=script&lang=js"
export * from "./accountSettingsixth.vue?vue&type=script&lang=js"
import style0 from "./accountSettingsixth.vue?vue&type=style&index=0&id=4f6560af&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6560af",
  null
  
)

export default component.exports